// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".audio-item[data-v-2594e160] {\n  max-width: 250px;\n}\n.audio-item .audio-label[data-v-2594e160] {\n  color: #586174;\n  font-size: 13px;\n}\n", ""]);
// Exports
module.exports = exports;
